var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCheckboxSelectedContainer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    fill: "white",
    stroke: "#4001C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5416 11.0417L12.7083 19.875C12.6301 19.9539 12.5236 19.9982 12.4125 19.9982C12.3014 19.9982 12.1949 19.9539 12.1166 19.875L7.62496 15.3833C7.54608 15.3051 7.50171 15.1986 7.50171 15.0875C7.50171 14.9764 7.54608 14.8699 7.62496 14.7917L8.20829 14.2083C8.28653 14.1294 8.39303 14.0851 8.50412 14.0851C8.61522 14.0851 8.72172 14.1294 8.79996 14.2083L12.4083 17.8167L20.3666 9.85833C20.5315 9.69851 20.7934 9.69851 20.9583 9.85833L21.5416 10.45C21.6205 10.5282 21.6649 10.6347 21.6649 10.7458C21.6649 10.8569 21.6205 10.9634 21.5416 11.0417Z",
    fill: "#4001C5"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxSelectedContainer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CheckboxSelectedContainer.6f92b413.svg";
export { ForwardRef as ReactComponent };